import { useState } from 'react'
import { PlusIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'

import { useCurrentWorkspace } from '../../store/hooks/useCurrentWorkspace'
import { WorkspaceType } from '../../lib/db/db.types'
import { CreateRepeatingEventForm } from './CreateRepeatingEventForm'
import { getRepeatDescription } from './RepeatDescription'

export function RepeatingEvents() {
  const { workspace, repeatingEvents } = useCurrentWorkspace()
  const navigate = useNavigate()

  const [showCreateForm, setShowCreateForm] = useState(false)

  if (!workspace) return null

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <button
          onClick={() => setShowCreateForm(true)}
          className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <PlusIcon className="h-5 w-5 mr-2" />
          New recurring event
        </button>
      </div>

      {repeatingEvents.length > 0 ? (
        <ul className="divide-y divide-gray-200 bg-white shadow rounded-lg">
          {repeatingEvents.map((event) => (
            <li
              key={event.id}
              className="p-6 hover:bg-gray-50 cursor-pointer"
              onClick={() =>
                navigate(`/workspace/${workspace.id}/manage-events/${event.id}`)
              }
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-medium text-gray-900">
                    {event.name}
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    {getRepeatDescription(event.repeats)}
                  </p>
                  {event.repeats.end && (
                    <p className="mt-1 text-sm text-gray-500">
                      Until {new Date(event.repeats.end).toLocaleDateString()}
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-4">
                  {!!event.repeats.exceptions && (
                    <div className="text-sm text-gray-500">
                      {event.repeats.exceptions.length} exception
                      {event.repeats.exceptions.length === 1 ? '' : 's'}
                    </div>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
          <h3 className="mt-2 text-sm font-medium text-gray-900">
            No calendar events configured
          </h3>
        </div>
      )}

      {showCreateForm && workspace && (
        <CreateRepeatingEventForm
          workspaceId={workspace.id}
          accountingReferenceDate={
            workspace.spaceType === WorkspaceType.BUSINESS
              ? workspace.calendarYearEndReferenceDate
              : undefined
          }
          onClose={() => setShowCreateForm(false)}
        />
      )}
    </div>
  )
}
